const AD_POSITION_FACTOR = 5;
export const canShow = (position: number): boolean => {
  return position === 2 || (position - 2) % AD_POSITION_FACTOR === 0;
};
